export default {
  title: 'Attorney Detail Report',
  backButton: 'All reports',
  attorneyFilterLabel: 'Filter by attorney',
  export: 'Export',
  adminBackButton: 'Back to MBD Reports',
};
